import api from './api';
import { Expense, ExpenseCategorySummary } from '../types';

const expenseService = {
  /**
   * Busca todas as despesas
   */
  getAllExpenses: async (): Promise<Expense[]> => {
    try {
      const response = await api.get('/expenses');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar despesas:', error);
      throw error;
    }
  },

  /**
   * Busca despesas de um veículo específico
   * @param vehicleId ID do veículo
   */
  getVehicleExpenses: async (vehicleId: number): Promise<Expense[]> => {
    const response = await api.get(`/vehicles/${vehicleId}/expenses`);
    return response.data;
  },

  /**
   * Busca um resumo das despesas por categoria para um veículo
   * @param vehicleId ID do veículo
   */
  getVehicleExpensesSummary: async (vehicleId: number): Promise<ExpenseCategorySummary[]> => {
    const response = await api.get(`/vehicles/${vehicleId}/expenses/summary`);
    return response.data;
  },

  /**
   * Busca uma despesa específica
   * @param id ID da despesa
   */
  getExpense: async (id: number): Promise<Expense> => {
    try {
      const response = await api.get(`/expenses/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar despesa ${id}:`, error);
      throw error;
    }
  },

  /**
   * Cria uma nova despesa
   * @param expense Dados da despesa
   */
  createExpense: async (expense: any): Promise<Expense> => {
    try {
      api.defaults.headers['Content-Type'] = 'multipart/form-data'

      const response = await api.post('/expenses', expense);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar despesa:', error);
      throw error;
    }
  },

  /**
   * Atualiza uma despesa existente
   * @param id ID da despesa
   * @param expense Dados atualizados da despesa
   */
  updateExpense: async (id: number, expense: any): Promise<Expense> => {
    try {
      // Formatar valor para número se for string
 
      api.defaults.headers['Content-Type'] = 'multipart/form-data'

      const response = await api.post(`/expenses/editar/${id}`, expense);
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar despesa ${id}:`, error);
      throw error;
    }
  },

  /**
   * Exclui uma despesa
   * @param id ID da despesa
   */
  deleteExpense: async (id: number): Promise<number>  => {
    try {
      const response = await    await api.delete(`/expenses/${id}`);
      return response.status;

    } catch (error) {
      console.error(`Erro ao excluir despesa ${id}:`, error);
      throw error;
    }
  },
  deleteImageExpense: async (id: any) => {
    try {
      const response = await api.delete(`expenses/${id}/images`);

      return response;

    } catch (error) {
      console.error(`Erro ao excluir veículo ${id}:`, error);
      throw error;
    }
  },
  /**
   * Busca os tipos de despesas disponíveis
   */
  getExpenseTypes: async (): Promise<string[]> => {
    const response = await api.get('/expense-types');
    return response.data;
  },

};

export default expenseService; 